import * as THREE from 'three';

/** A fixed shader light budget; fixtures remain visible even outside this pool. */
export class LocalLightPool {
  readonly group = new THREE.Group();
  private sources: THREE.PointLight[] = [];
  private readonly lights: THREE.PointLight[];

  constructor(count = 8) {
    this.lights = Array.from({ length: count }, () => new THREE.PointLight(0xffffff, 0, 7, 2));
    this.group.add(...this.lights);
  }

  bind(root: THREE.Object3D): void {
    this.sources = [];
    root.traverse(object => {
      if (object instanceof THREE.PointLight) {
        this.sources.push(object);
        object.visible = false;
      }
    });
    root.updateMatrixWorld(true);
  }

  update(camera: THREE.Camera): void {
    const position = camera.getWorldPosition(new THREE.Vector3());
    const candidates = this.sources.map(light => ({
      light, position: light.getWorldPosition(new THREE.Vector3()),
    })).filter(source => Math.abs(source.position.y - position.y) < 2.5)
      .sort((a, b) => a.position.distanceToSquared(position) - b.position.distanceToSquared(position));
    this.lights.forEach((target, index) => {
      const source = candidates[index];
      target.intensity = source?.light.intensity ?? 0;
      if (!source) return;
      target.position.copy(source.position);
      target.color.copy(source.light.color);
      target.distance = source.light.distance;
      target.decay = source.light.decay;
    });
  }
}
